/**
 * Inizializza il FAB che porta alla mappa delle Commissioni regionali.
 *
 * @param {HTMLButtonElement} button Pulsante FAB.
 * @returns {void}
 */
export default function initCommissioniRegionaliFab(button) {
    if (!button) {
        return;
    }

    const targetSelector = button.dataset.scrollTarget || "";
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    let target = null;

    try {
        target = targetSelector ? document.querySelector(targetSelector) : null;
    } catch (error) {
        target = null;
    }

    if (!target) {
        return;
    }

    let isVisible = false;

    function setVisible(nextVisible) {
        if (nextVisible === isVisible) {
            return;
        }

        isVisible = nextVisible;
        button.classList.toggle("is-visible", isVisible);
        button.setAttribute("aria-hidden", isVisible ? "false" : "true");
        button.tabIndex = isVisible ? 0 : -1;
    }

    button.addEventListener("click", () => {
        if (reduceMotion.matches) {
            target.scrollIntoView({ block: "start" });
            return;
        }

        target.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    });

    setVisible(true);
}
